import React from 'react';
import { Grid, Box, Typography, Avatar, Chip } from '@mui/material';

const Listing = ({ workOrders, page }) => {
  // Calculate the starting and ending indices for the current page
  const rowsPerPage = 10;
  const startIndex = (page - 1) * rowsPerPage;
  const paginatedWorkOrders = workOrders.slice(startIndex, startIndex + rowsPerPage);

  return (
    <Grid container spacing={2}>
      {paginatedWorkOrders.map((order) => (
        <Grid item xs={12} key={order.id} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }} onClick={() => alert(`Clicked on Order No: ${order.orderNo}`)}>
          {/* Work Order Card */}
          <Box sx={{ 
            padding: 2, 
            border: '1px solid #ddd', 
            borderRadius: 2, 
            display: 'flex', 
            flexDirection: 'column', 
            width: '100%', 
            backgroundColor: 'black', 
            boxShadow: 2
          }}>

            {/* Work Order Details */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}>
              <Avatar sx={{ backgroundColor: '#FF4081' }}>
                {order.orderNo.charAt(3)} {/* Display the first character of orderNo for avatar */}
              </Avatar>
              <Typography variant="body2" sx={{ flex: 1 }}>{order.orderNo}</Typography>
              <Typography variant="body2" sx={{ flex: 1 }}>{order.description}</Typography>
              <Typography variant="body2" sx={{ flex: 1 }}>{order.location}</Typography>
              <Typography variant="body2" sx={{ flex: 1 }}>{order.date}</Typography>
              <Chip label={order.status} sx={{ backgroundColor: '#FF4081', color: 'white' }} />
            </Box>

            
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default Listing;
